import { render, staticRenderFns } from "./ProjectsManager.vue?vue&type=template&id=597367fa&scoped=true"
import script from "./ProjectsManager.vue?vue&type=script&lang=js"
export * from "./ProjectsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597367fa",
  null
  
)

export default component.exports